import * as React from "react"

// Utils
import UniversalLink from "§/src/utils/UniversalLink"

// Unternals
import "./_tile-button-content.scss"

// Atoms
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

const TileButtonContent = props => {
  const {
    pretitle,
    title,
    content,
    cta,
    template,
    buttonTemplate,
    ...atomProps
  } = props.data

  var buttonColorClass =
    template == "white"
      ? "text-primary"
      : template == "blue"
      ? "text-white"
      : "text-dark"
  if (buttonTemplate == "lg-right") {
    var buttonDir = "top-end"
    var buttonColorClass = buttonColorClass + " ms-auto icon-lg"
  } else {
    var buttonDir = "end"
    var buttonColorClass = buttonColorClass + " me-auto"
  }

  // set atom class
  const atomClassName = "tile-content temp-" + template
  var atomClass =
    props.className != undefined
      ? atomClassName + " " + props.className
      : atomClassName

  return (
    <div className={atomClass} {...atomProps}>
      <div className="card h-100">
        <div className="card-body">
          {pretitle && (
            <span className="card-pretitle fs-9 text-uppercase mb-2">
              {pretitle}
            </span>
          )}

          {title && <h5 className="card-title h3">{title}</h5>}

          {content && <p className="card-text">{content}</p>}

          <ButtonArrow
            dir={buttonDir}
            text={cta[2]}
            className={buttonColorClass + " cta stretched-link mt-auto"}
            onClick={props.onClick}
            data-bs-toggle="modal"
            data-bs-target={`#${props?.modalid}`}
          ></ButtonArrow>
        </div>
      </div>
    </div>
  )
}

export default TileButtonContent
